import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface RefereeFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const RefereeForm: React.FC<RefereeFormProps> = ({
  updateDetails,
  data
}) => {
  const [leagueInput, setLeagueInput] = useState('');
  const handleAddLeague = () => {
    if (leagueInput.trim() !== '') {
      const currentLeagues = data.profileDetails?.leagues || [];
      updateDetails({
        leagues: [...currentLeagues, leagueInput.trim()]
      });
      setLeagueInput('');
    }
  };
  const handleRemoveLeague = (index: number) => {
    const currentLeagues = [...(data.profileDetails?.leagues || [])];
    currentLeagues.splice(index, 1);
    updateDetails({
      leagues: currentLeagues
    });
  };
  return <div className="space-y-4" data-id="element-165">
      <div data-id="element-166">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-167">
          Referee Level
        </label>
        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" value={data.profileDetails?.refereeLevel || ''} onChange={e => updateDetails({
        refereeLevel: e.target.value
      })} data-id="element-168">
          <option value="" data-id="element-169">Select level</option>
          <option value="Local" data-id="element-170">Local</option>
          <option value="Regional" data-id="element-171">Regional</option>
          <option value="National" data-id="element-172">National</option>
          <option value="International" data-id="element-173">International</option>
          <option value="FIFA" data-id="element-174">FIFA</option>
        </select>
      </div>
      <div data-id="element-175">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-176">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 9" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-177" />
      </div>
      <div data-id="element-178">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-179">
          Leagues/Tournaments Officiated
        </label>
        <div className="flex" data-id="element-180">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Premier League" value={leagueInput} onChange={e => setLeagueInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddLeague())} data-id="element-181" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddLeague} data-id="element-182">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-183">
          {(data.profileDetails?.leagues || []).map((league, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-184">
              <span className="flex-1" data-id="element-185">{league}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveLeague(index)} data-id="element-186">
                <XIcon size={16} data-id="element-187" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default RefereeForm;